export default "__VITE_ASSET__CwmPv12K__"